import './decline-banner.scss';

import PropTypes from 'prop-types';
import React from 'react';

const DeclineBanner = ({ reasons }) => {
  return (
    <div className="decline-banner" data-testid="decline-banner">
      <h4 className="decline-banner__heading">This section was declined</h4>
      <p className="decline-banner__message">
        Please review and update the information below, then re-submit.
      </p>
      {reasons.length > 0 && (
        <div className="decline-banner__reasons">
          {reasons.map((reason, index) => (
            <blockquote key={index} className="decline-banner__reason">
              {reason}
            </blockquote>
          ))}
        </div>
      )}
    </div>
  );
};

DeclineBanner.propTypes = {
  reasons: PropTypes.arrayOf(PropTypes.string).isRequired
};

export { DeclineBanner };
